import React from 'react'
import styles from './NavMain.module.css'
import { Link } from 'react-router-dom'
// import Hm from '../../asssists/HM.png'
export default function NavMain() {
  return (
    <>
    <nav className={`navbar navbar-expand-lg ${styles.navbar} `}>
    <div className="container">
    
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="d-flex flex-column m-auto mb-2 mb-lg-0">
       
         <div className={styles.allBoxes}>
         <Link to="/" className={`${styles.boxliNav} nav-link`}>
  
         <li className="d-flex flex-column justify-content-center align-items-center">
         <i className="fa-solid fa-house"></i>
           <Link className="nav-link active mx-3" aria-current="page" >Home</Link>
         </li>
         </Link>


         <Link to="/contact"  className={`${styles.boxliNav} nav-link`}>
         <li className="d-flex flex-column justify-content-center align-items-center">
         <i className="fa-solid fa-hands-asl-interpreting"></i>
           <Link className="nav-link mx-3">Contact</Link>
         </li>
         </Link>
         <Link to="/projects"  className={`${styles.boxliNav} nav-link`}>
         <li className="d-flex flex-column justify-content-center align-items-center">
         <i className="fa-solid fa-dragon"></i>
           <Link className="nav-link mx-3" >Projects</Link>
         </li>
         </Link>


         
         </div>
        
  
      
  
        </ul>
       
      </div>
    </div>
  </nav>
  
    </>
  )
}
